import React from 'react';

import { Branch } from 'src/components/GoogleMaps/GoogleMapsTypes';

import classes from './styles/Branch.scss';

function BranchCard({ branch }: { branch: Branch }) {
    return (
        <div className={classes.branch}>
            <div className={classes.storeLocator__upper}>
                <p className={['h2', classes.storeLocator__name].join(' ')}>{branch.name}</p>
                <span className={classes.distance}>{branch.distance_km?.toFixed(2)}km</span>
            </div>

            <div className={classes.storeLocator__lower}>
                <a className={classes.link} href={branch.url}>
                    View store details
                </a>
            </div>
        </div>
    );
}

export { BranchCard };
